function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  isPlainObject
} = require('lodash');
const {
  appendPath,
  getContentValue,
  mutateContentValue
} = require('@truqc/content-path');
const {
  mergeDeepLeft
} = require('ramda');
const {
  evaluateSource,
  evaluateVariables
} = require('./evaluateSource');
const {
  expandSingleCollection,
  expandWithLabel
} = require('./expandCollections');
const {
  profile
} = require('./profile');
const clone = data => JSON.parse(JSON.stringify(data));
const addIdentifiers = (formatIn, path = '$') => {
  let formatOut;
  if (Array.isArray(formatIn)) {
    const counts = {};
    formatIn.forEach(item => {
      const {
        contentPath
      } = item;
      if (contentPath) {
        counts[contentPath] = (counts[contentPath] || 0) + 1;
      }
    });
    formatOut = formatIn.map((item, index) => {
      const {
        contentPath
      } = item;
      let identifier = `${path}`;
      if (contentPath === undefined) {
        identifier += `.${index}`;
      } else if (counts[contentPath] > 1) {
        identifier += `.${contentPath}-${index}`;
      } else {
        identifier += `.${contentPath}`;
      }
      return addIdentifiers(item, identifier);
    });
  } else if (isPlainObject(formatIn)) {
    formatOut = {};
    Object.keys(formatIn).forEach(key => {
      if (key === 'children') {
        formatOut[key] = addIdentifiers(formatIn[key], path);
      } else {
        formatOut[key] = formatIn[key];
      }
    });
    formatOut.identifier = path;
  } else {
    formatOut = formatIn;
  }
  return formatOut;
};
const evaluateFormat = async (contentIn, wholeFormatIn, /* eslint-disable-next-line default-param-last */
contentParentPath = '', nativeFunctions, excludePropertyMap = {}, whitelistProperties = []) => {
  const content = clone(contentIn);
  const profileEvaluateFormat = profile('evaluateFormat');
  // defer evaluation of various properties
  // which are to be evaluated through other mechanisms
  const skipEval = ['type', 'children', 'behaviors', 'actions', 'preActions', 'postActions', 'onAddBatch', 'onAddHistory', 'deferredOptions', 'validation'];
  const recursiveReplace = async (formatIn, path, containerType, prevCascadingProperties, transientContext, breadcrumbs = []) => {
    const recursiveReplaceProf = profile('recursiveReplace');
    // we don't want to waste time on non-visible nodes,
    // so evaluate those first and ignore them if
    // visible === false.

    let variables = {};
    if ((whitelistProperties === null || whitelistProperties === void 0 ? void 0 : whitelistProperties.length) === 0) {
      variables = await evaluateVariables(formatIn.variables, content, path, transientContext, nativeFunctions);
    }
    let visible;
    if ((whitelistProperties === null || whitelistProperties === void 0 ? void 0 : whitelistProperties.length) === 0 && formatIn.visible !== undefined) {
      visible = await evaluateSource(formatIn.visible, content, path, variables, nativeFunctions);
      if (visible === false) {
        return undefined;
      }
    }

    // EXPAND COLLECTIONS

    // this variable container type is to address the
    // 'outerCollection' vs 'innerCollection' in pdfgen.
    // We want to clean that up such that we return
    // the same thing from a collection in all cases.
    const childContainerType = formatIn.type === 'section' ? 'v1Container' : containerType;
    let format = formatIn;
    if (formatIn.type === 'collection') {
      const profileExpandCollections = profile('expandCollections');
      const fullPath = appendPath(path, formatIn.contentPath);
      if (formatIn.value !== undefined) {
        const transientCollection = await evaluateSource(formatIn.value, content, path, transientContext, nativeFunctions);

        // real content should take precedence over transient value
        const realCollection = getContentValue(fullPath, content);
        const mergedCollection = mergeDeepLeft(realCollection, transientCollection);

        // overwrite the collection in the working copy of content
        // (only exists for the duration of this format evaluation pass)
        mutateContentValue(fullPath, content, mergedCollection);
      }
      const itemDictionary = getContentValue(fullPath, content);
      const expandedCollection = expandSingleCollection(formatIn, itemDictionary, childContainerType);
      format = expandWithLabel(expandedCollection, formatIn);
      profileExpandCollections.end();
    }

    // EVALUATE PROPERTIES

    const cascadingProperties = {
      under: _objectSpread({}, prevCascadingProperties.under),
      over: _objectSpread({}, prevCascadingProperties.over)
    };
    // declare this to make it available
    // to evaluate children, but we
    // need to update it AFTER evaluating
    // all properties as they may need
    // to be eval'ed before adding
    // to the crumb list.
    const crumbs = JSON.parse(JSON.stringify(breadcrumbs));
    const evaluateChildren = async children => {
      if (!Array.isArray(children)) {
        return [];
      }
      const newPath = appendPath(path, format.contentPath);
      const newChildren = [];
      for (let childIndex = 0; childIndex < children.length; childIndex += 1) {
        const child = children[childIndex];
        /* eslint-disable-next-line no-await-in-loop */
        const newChild = await recursiveReplace(child, newPath, childContainerType, cascadingProperties, variables, crumbs);
        if (newChild !== null && newChild !== undefined) {
          newChildren.push(newChild);
        }
      }
      return newChildren;
    };
    const evaluateOther = async (key, other) => {
      const {
        cascade
      } = other;
      const result = await evaluateSource(other, content, path, variables, nativeFunctions);

      // `cascadingProperties` are separated into `over` and `under`
      if (cascade !== undefined && result !== undefined) {
        if (cascadingProperties[cascade] === undefined) {
          cascadingProperties[cascade] = {};
        }
        cascadingProperties[cascade][key] = result;
      }
      return result;
    };
    const evaluateHeaderFooter = async footerHeader => {
      var _footerHeader$title, _footerHeader$title2, _footerHeader$title3;
      let result;
      const assignHeaderFooterValue = async (prop, footerHeaderFormat) => {
        if (footerHeaderFormat !== undefined) {
          const evalFormat = await evaluateOther(prop, footerHeaderFormat);
          if (evalFormat !== undefined) {
            if (result === undefined) {
              result = {};
            }
            result[prop] = evalFormat;
          }
        }
      };
      const footerHeaderKeys = Object.keys(footerHeader);
      for (let i = 0; i < footerHeaderKeys.length; i += 1) {
        /* eslint-disable-next-line no-await-in-loop */
        await assignHeaderFooterValue(footerHeaderKeys[i], footerHeader[footerHeaderKeys[i]]);
      }
      const left = await evaluateOther('left', (footerHeader === null || footerHeader === void 0 || (_footerHeader$title = footerHeader.title) === null || _footerHeader$title === void 0 ? void 0 : _footerHeader$title.left) || '');
      const center = await evaluateOther('center', (footerHeader === null || footerHeader === void 0 || (_footerHeader$title2 = footerHeader.title) === null || _footerHeader$title2 === void 0 ? void 0 : _footerHeader$title2.center) || '');
      const right = await evaluateOther('right', (footerHeader === null || footerHeader === void 0 || (_footerHeader$title3 = footerHeader.title) === null || _footerHeader$title3 === void 0 ? void 0 : _footerHeader$title3.right) || '');
      if (!left && !center && !right) {
        return result;
      }
      result.title = {
        left,
        center,
        right
      };
      return result;
    };
    const keys = Object.keys(format);
    const excludeProperties = excludePropertyMap[format.type] || [];
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      const skip = skipEval.includes(key) || excludeProperties.includes(key);
      const isWhitelisted = (whitelistProperties === null || whitelistProperties === void 0 ? void 0 : whitelistProperties.length) > 0 && whitelistProperties.includes(key);
      if (!skip || isWhitelisted) {
        const value = format[key];
        if (key === 'visible') {
          format[key] = visible; // true or undefined
        } else if (key === 'variables') {
          format[key] = variables;
        } else {
          /* eslint-disable-next-line no-await-in-loop */
          format[key] = await evaluateOther(key, value);
        }
        if (format[key] === null || format[key] === undefined) {
          delete format[key];
        }
      }
    }
    if (format.header !== undefined && !excludeProperties.includes('header')) {
      format.header = await evaluateHeaderFooter(format.header);
    }
    if (format.footer !== undefined && !excludeProperties.includes('footer')) {
      format.footer = await evaluateHeaderFooter(format.footer);
    }

    // now that props have been eval'ed,
    // we can add them to the breadcrumbs.
    if (format.breadcrumb !== undefined) {
      crumbs.push(format.breadcrumb);
    } else {
      if (format.label !== undefined && format.label !== '') {
        crumbs.push(format.label);
      }
      if (format.title !== undefined) {
        crumbs.push(format.title);
      }
    }
    // evaluate children last, in case of other properties cascading
    if (format.children !== undefined && !excludeProperties.includes('children')) {
      format.children = await evaluateChildren(format.children);
    }

    // The component's own properties override `under` properties,
    // but are overridden by `over` properties.
    format = _objectSpread(_objectSpread(_objectSpread({}, prevCascadingProperties.under), format), cascadingProperties.over);
    if (typeof format.breadcrumbSeparator === 'string') {
      format.breadcrumbs = crumbs.join(format.breadcrumbSeparator);
    }
    recursiveReplaceProf.end();
    return format;
  };
  const isEmptyContainer = component => {
    var _component$children$l, _component$children;
    return component.type === 'v1Container' && ((_component$children$l = (_component$children = component.children) === null || _component$children === void 0 ? void 0 : _component$children.length) !== null && _component$children$l !== void 0 ? _component$children$l : 0) === 0;
  };
  const removeEmptyContainers = component => {
    if (Array.isArray(component.children)) {
      // eslint-disable-next-line no-param-reassign
      component.children = component.children.map(child => removeEmptyContainers(child)).filter(child => !isEmptyContainer(child));
    }
    return component;
  };

  // add identifiers before removing invisible nodes
  // so that identifiers are static regardless of visibility.

  const wholeFormatCopy = JSON.parse(JSON.stringify(wholeFormatIn));
  const containerType = wholeFormatIn.type === 'report' ? 'volume' : 'v1Container';
  let result = await recursiveReplace(wholeFormatCopy, contentParentPath, containerType, {});
  result = addIdentifiers(result);
  result = removeEmptyContainers(result);
  profileEvaluateFormat.end();
  return result;
};
const preEvaluateFormat = async (formatIn, content, nativeFunctions, evaluateEvents) => {
  // simple pre-evaluation (no collection expansion or property recursion)
  // for properties with behaviors containing `event` types.

  const match = incomingEvent => {
    let event = incomingEvent;
    if (evaluateEvents === undefined || event === undefined) {
      return false;
    }
    if (typeof event === 'string') {
      event = [event];
    }
    return evaluateEvents.some(behaviorEvent => event.includes(behaviorEvent));
  };
  const replaceInPlace = async (parent, path) => {
    const keys = Object.keys(parent);
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      const value = parent[key];
      if (key === 'children' && Array.isArray(value)) {
        for (let j = 0; j < value.length; j += 1) {
          const child = value[j];
          /* eslint-disable-next-line no-await-in-loop */
          await replaceInPlace(child, appendPath(path, parent.contentPath));
        }
      } else if (key !== 'children') {
        const {
          type,
          event
        } = value;
        if (type !== undefined && match(event)) {
          const format = parent;
          const transientContext = {};
          /* eslint-disable-next-line no-await-in-loop */
          const result = await evaluateSource(value, content, path, transientContext, nativeFunctions);
          format[key] = result;
        }
      }
    }
  };
  const formatOut = JSON.parse(JSON.stringify(formatIn));
  await replaceInPlace(formatOut, '/');
  return formatOut;
};
module.exports = {
  evaluateFormat,
  preEvaluateFormat
};